import type { CSSProperties } from 'react'

export function Skeleton({ className = '', style }: { className?: string; style?: CSSProperties }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-netral-200 ${className}`}
      style={style}
      aria-hidden="true"
    />
  )
}

export function SkeletonTeks({ baris = 3 }: { baris?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: baris }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i === baris - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  )
}

export function SkeletonTabel({ baris = 6, kolom = 5 }: { baris?: number; kolom?: number }) {
  return (
    <div className="space-y-2 p-2">
      {Array.from({ length: baris }).map((_, r) => (
        <div
          key={r}
          className="grid gap-3"
          style={{ gridTemplateColumns: `repeat(${kolom}, minmax(0, 1fr))` }}
        >
          {Array.from({ length: kolom }).map((_, c) => (
            <Skeleton key={c} className="h-4" />
          ))}
        </div>
      ))}
    </div>
  )
}

export function SkeletonKartu({ jumlah = 4 }: { jumlah?: number }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: jumlah }).map((_, i) => (
        <div key={i} className="rounded-xl border border-netral-200 bg-white p-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-3 h-7 w-32" />
          <Skeleton className="mt-2 h-3 w-20" />
        </div>
      ))}
    </div>
  )
}

export function SkeletonGrafik({ tinggi = 280 }: { tinggi?: number }) {
  return (
    <div className="space-y-3">
      <Skeleton className="h-4 w-40" />
      <Skeleton style={{ height: tinggi }} className="w-full" />
    </div>
  )
}
